module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-36.b048f4f2.png";